import React, { Component } from "react";
import {
  Button,
  Table,
  Form,
  DatePicker,
  Input,
  Select,
  message,
  Row,
  Col,
} from "antd";
import {
  _franchiseeList,
  _fastChargeLogList,
  _batteryChargeList,
  _exportInsureFastChargeLog,
  _fastChargeCapacityMoney,
} from "@/statics/js/api";
import moment from "moment";
import { getJurisdiction } from "@/statics/js/jurisdiction";

const RangePicker = DatePicker.RangePicker;
const Option = Select.Option;
class FastChargeLogList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: 10, // 每页展示个数
      curPage: 1, //当前页数
      totalCount: 0, //数据总数量
      batteryChargeList: [], //电柜列表
      franchiseeList: [], //代理商列表
      fastChargeLogList: [], //充电桩列表
      fastChargeCapacityMoney: {}, //充电桩统计
    };
    this.columns = [
      {
        title: "序号",
        width: 90,
        dataIndex: "id",
      },
      {
        title: "充电单号",
        width: 140,
        align: "right",
        dataIndex: "blotterId",
      },
      {
        title: "代理商",
        dataIndex: "fname",
      },
      {
        title: "电柜名称(快充点)",
        dataIndex: "chargeName",
      },
      {
        title: "充电桩编号",
        width: 120,
        align: "right",
        dataIndex: "fastChargeImei",
      },
      {
        title: "电池二维码",
        width: 120,
        align: "right",
        dataIndex: "batteryImei",
      },
      {
        title: "商户电价",
        dataIndex: "agentPrice",
        render: (text) => text && text + "kW·h",
      },
      {
        title: "用户电价",
        dataIndex: "userPrice",
        render: (text) => text && text + "kW·h",
      },

      {
        title: "用户",
        dataIndex: "yid",
      },
      {
        title: "开始时间",
        width: 120,
        dataIndex: "startTimes",
      },
      {
        title: "结束时间",
        width: 120,
        dataIndex: "endTimes",
      },
      {
        title: "充电量",
        dataIndex: "capacity",
        render: (text) => (text ? text + "kW·h" : null),
      },
      {
        title: "费用",
        dataIndex: "userMoney",
      },
      {
        title: "支付状态",
        dataIndex: "payState",
        render: (text) => (text == 1 ? "未支付" : text == 2 ? "已支付" : ""),
      },
      {
        title: "支付方式",
        dataIndex: "payMent",
        render: (text) =>
          text == 1
            ? "余额"
            : text == 2
            ? "充电钱包"
            : text == 3
            ? "支付宝"
            : "",
      },
    ];
  }
  // 筛选表头
  renderForm() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit}>
        <Row gutter={16}>
          <Col lg={6} md={12} sm={24}>
            <Form.Item label="代理商">
              {getFieldDecorator("fid")(
                <Select
                  placeholder="请选择"
                  onChange={this.getBatteryChargeList.bind(this)}
                  allowClear
                  showSearch
                  filterOption={(input, option) => {
                    return (
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    );
                  }}
                >
                  <Option value="">全部</Option>
                  {this.state.franchiseeList.length &&
                    this.state.franchiseeList.map((item, index) => {
                      return (
                        <Option key={index} value={item.fid}>
                          {item.fname}
                        </Option>
                      );
                    })}
                </Select>
              )}
            </Form.Item>
          </Col>
          <Col lg={6} md={12} sm={24}>
            <Form.Item label="电柜名称(快充点)">
              {getFieldDecorator("cid")(
                <Select
                  placeholder="请选择"
                  allowClear
                  showSearch
                  filterOption={(input, option) => {
                    return (
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    );
                  }}
                >
                  <Option value="">全部</Option>
                  {this.state.batteryChargeList.length &&
                    this.state.batteryChargeList.map((item, index) => {
                      return (
                        <Option key={index} value={item.id}>
                          {item.chargeName}
                        </Option>
                      );
                    })}
                </Select>
              )}
            </Form.Item>
          </Col>
          <Col lg={6} md={12} sm={24}>
            <Form.Item label="充电桩编号">
              {getFieldDecorator("fastChargeImei")(
                <Input allowClear placeholder="请输入" />
              )}
            </Form.Item>
          </Col>

          <Col lg={6} md={12} sm={24}>
            <Form.Item label="选择时间">
              {getFieldDecorator("selectDate")(
                <RangePicker format="YYYY-MM-DD" />
              )}
            </Form.Item>
          </Col>
          <Col lg={6} md={12} sm={24}>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                搜索
              </Button>
              <Button
                disabled={!getJurisdiction(915)}
                title={getJurisdiction(915) ? "" : "暂无操作权限！"}
                onClick={this.handleExportChange.bind(this)}
                style={{ marginLeft: 10 }}
                loading={this.state.exportload}
              >
                导出
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  }
  render() {
    const {
      totalCount,
      curPage,
      pageSize,
      fastChargeLogList,
      fastChargeCapacityMoney,
    } = this.state;
    return (
      <div>
        {getJurisdiction(914) ? (
          <div className="FastChargeLogList">
            <div className="select-form">{this.renderForm()}</div>
            <div
              style={{
                lineHeight: "56px",
                background: "#F4F4F4",
                borderRadius: "5px",
                marginBottom: "10px",
                padding: "0 50px",
                color: "#4D4D4D",
              }}
            >
              充电量：
              <span
                style={{
                  padding: "0 50px 0 10px",
                  fontWeight: 500,
                  fontSize: "18px",
                }}
              >
                {fastChargeCapacityMoney.countCapacity
                  ? fastChargeCapacityMoney.countCapacity + "kW·h"
                  : 0}
              </span>
              用户费用：
              <span
                style={{
                  padding: "0 50px 0 10px",
                  fontWeight: 500,
                  fontSize: "18px",
                }}
              >
                {fastChargeCapacityMoney.userMoney
                  ? fastChargeCapacityMoney.userMoney + "元"
                  : 0}
              </span>
              商家费用：
              <span
                style={{
                  padding: "0 50px 0 10px",
                  fontWeight: 500,
                  fontSize: "18px",
                }}
              >
                {fastChargeCapacityMoney.agentMoney
                  ? fastChargeCapacityMoney.agentMoney + "元"
                  : 0}
              </span>
            </div>
            <div className="content-table">
              <Table
                rowKey="id"
                bordered
                columns={this.columns}
                dataSource={fastChargeLogList}
                scroll={{ x: 1600, y: 500 }}
                pagination={{
                  showQuickJumper: true,
                  defaultPageSize: pageSize,
                  showSizeChanger: true,
                  onShowSizeChange: this.handlePageChange.bind(this),
                  onChange: this.handlePageChange.bind(this),
                  total: totalCount,
                  current: curPage,
                  showTotal: (totalCount) => `总共 ${totalCount} 条记录`,
                }}
              />
            </div>
          </div>
        ) : (
          "暂无操作权限！"
        )}
      </div>
    );
  }
  componentDidMount() {
    localStorage.getItem("type") === "1"
      ? this.getBatteryChargeList(localStorage.getItem("fid"))
      : this.getFranchiseeList();
    this.getFastChargeCapacityMoney(this.state.queryFormValues);
    this.getFastChargeLogList(
      this.state.curPage,
      this.state.pageSize,
      this.state.queryFormValues
    );
  }

  //获取代理商列表
  getFranchiseeList() {
    let params = {
      curPage: 1,
      pageSize: 999,
    };
    _franchiseeList(params)
      .then((res) => {
        if (res.data.code === 200) {
          if (!res.data.data.rows.length) {
          }
          this.setState({
            franchiseeList: res.data.data.rows,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //获取站点列表
  getBatteryChargeList(value) {
    this.props.form.setFieldsValue({
      sid: undefined,
    });
    let params = {
      fid: value,
      chargeType: 3,
      curPage: 1,
      pageSize: 999,
    };
    _batteryChargeList(params)
      .then((res) => {
        if (res.data.code === 200) {
          this.setState({
            batteryChargeList: res.data.data.rows,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //获取充电桩统计
  getFastChargeCapacityMoney(queryFormValues) {
    let params = {
      ...queryFormValues,
    };
    _fastChargeCapacityMoney(params)
      .then((res) => {
        if (res.data.code === 200) {
          this.setState({
            fastChargeCapacityMoney: res.data.data,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //获取充电桩报表
  getFastChargeLogList(curPage, pageSize, queryFormValues) {
    let params = {
      ...queryFormValues,
      curPage: curPage,
      pageSize: pageSize,
    };
    _fastChargeLogList(params)
      .then((res) => {
        if (res.data.code === 200) {
          if (!res.data.data.rows.length) {
            message.warning("暂无数据！");
          }
          this.setState({
            fastChargeLogList: res.data.data.rows,
            totalCount: res.data.data.totalCount,
            curPage: curPage,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //分页
  handlePageChange(curPage, pageSize) {
    this.getFastChargeLogList(curPage, pageSize, this.state.queryFormValues);
  }

  // 表单筛选
  handleSubmit = (e) => {
    e.preventDefault();
    const { form } = this.props;
    form.validateFields((err, values) => {
      if (err) return;
      for (let key in values) {
        if (
          values[key] === undefined ||
          values[key] === null ||
          values[key] === ""
        ) {
          delete values[key];
        }
      }
      if (values.selectDate && values.selectDate.length) {
        values.pushTimeStart = moment(values.selectDate[0]).format(
          "YYYY-MM-DD"
        );
        values.pushTimeEnd = moment(values.selectDate[1]).format("YYYY-MM-DD");
      }
      delete values.selectDate;
      this.setState({
        queryFormValues: values,
      });
      this.getFastChargeLogList(1, this.state.pageSize, values);
      this.getFastChargeCapacityMoney(values);
    });
  };

  // 导出
  handleExportChange = (e) => {
    e.preventDefault();
    this.setState({
      exportload: true,
    });
    const { form } = this.props;
    form.validateFields((err, values) => {
      if (err) return;
      for (let key in values) {
        if (
          values[key] === undefined ||
          values[key] === null ||
          values[key] === ""
        ) {
          delete values[key];
        }
      }
      if (values.selectDate && values.selectDate.length) {
        values.pushTimeStart = moment(values.selectDate[0]).format(
          "YYYY-MM-DD"
        );
        values.pushTimeEnd = moment(values.selectDate[1]).format("YYYY-MM-DD");
      }
      let params = {
        ...values,
      };
      _exportInsureFastChargeLog(params)
        .then((res) => {
          if (res.data.code === 200) {
            this.setState({
              exportload: false,
            });
            window.open(`${res.data.data}`, "_blank").focus();
          } else {
            message.warning(res.data.message);
            this.setState({
              exportload: false,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  };
}

FastChargeLogList = Form.create({})(FastChargeLogList);
export { FastChargeLogList };
